const ship = {
  effectiveDate: "latest updated at 23-Sept-2024",
  title: "Shipping Policy",
  des: "Welcome to Jaano.ai! We’re committed to delivering a smooth and timely digital experience. Below are the details of our shipping policy for our chatbot services:",
  sections: [
    {
      heading: "Service Delivery",
      exceptions: [
        "Digital-Only Delivery: Our chatbot services are entirely digital and will be accessible online. No physical products are shipped.",
        "Service Activation: Once payment is confirmed, the service will be activated and setup details sent via email to the registered email address.",
      ],
      content:
        "Users can access the chatbot services from any device with internet connectivity.",
    },
    {
      heading: "Estimated Delivery Time",
      exceptions: [
        "Initial Access: Access to the chatbot platform is typically granted within 24-48 hours of confirmed payment.",
        "Custom Integrations: For services that require custom integrations or specific setup, please allow 3-5 business days from the order confirmation date.",
      ],
      content:
        "We strive to deliver initial access as quickly as possible, and customers will be notified if there are any delays.",
    },
    {
      heading: "Delivery Method",
      exceptions: [
        "Email & Dashboard Access: Activation details, login credentials, and other service information will be sent via email. Clients can access the chatbot service through their account on our platform once credentials are received.",
        "Support and Assistance: Our support team is available to assist with any setup or activation issues.",
      ],
      content:
        "Customers are encouraged to check their spam or junk folders if they do not receive the activation email.",
    },
    {
      heading: "Notification of Delivery",
      exceptions: [
        "Confirmation Email: After purchase, a confirmation email will be sent with order details.",
        "Completion Notification: Once the service is fully set up, a completion email will confirm that the chatbot is ready for use.",
      ],
      content:
        "Confirmation emails include essential details such as order number and service description.",
    },
    {
      heading: "Failure of Delivery",
      exceptions: [
        "Delayed Access: If you do not receive access within the specified time, please reach out to our support team at info@jaano.ai.",
        "Refunds for Non-Delivery: If access to our chatbot service cannot be provided within the specified timeframe due to an error on our part, a full refund may be issued.",
      ],
      content:
        "In the event of delayed access, we will work diligently to resolve the issue as quickly as possible.",
    },
    {
      heading: "Questions and Support",
      content:
        "For any questions regarding your order or if you encounter any issues, please contact our support team:",
      contactInfo: {
        email: "info@jaano.ai",
        chat: "Available through our website chat feature",
      },
      subcontent:
        "Our support team is available during business hours to assist you with any queries.",
    },
  ],
};

export default ship;
